import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/placeholder/styles.scss';export default {
  "placeholder": "_placeholder_r3ov0_1",
  "main": "_main_r3ov0_9",
  "title": "_title_r3ov0_13",
  "subTitle": "_subTitle_r3ov0_20",
  "menu": "_menu_r3ov0_27",
  "menuItem": "_menuItem_r3ov0_38",
  "menuText": "_menuText_r3ov0_53",
  "iconBox": "_iconBox_r3ov0_59",
  "icon": "_icon_r3ov0_59",
  "fileIcon": "_fileIcon_r3ov0_71",
  "lockIcon": "_lockIcon_r3ov0_76",
  "block": "_block_r3ov0_80"
};